import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { RedisField } from './CreateRedisExtension';

export const CreateRedisExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RedisField',
    component: RedisField,
  }),
);
